import React, { useContext, useEffect, useState } from 'react';
import { TransitionContext } from '../Context/TransitionContext';

import './Terms.css';

import { useScreenTransition } from '../Hooks/useScreenTransition';
import SignInForm from './SignIn/SignInForm';
import CreateAccount from './CreateAccount/CreateAccount';


import Navbar from './HomePage/header';

import Footer from './HomePage/footer';
import SupportSection from './HomePage/SupportSection';




const Privacy = ({ windowSize }) => {
  
  const privacyPolicy = [
    {
      tilte:'Personal Information We Collect',
       content: <>We use the Order Information that we collect generally to fulfill any orders placed through the Site (including processing your payment information, arranging for shipping, and providing you with order confirmations). Additionally, we use this Order Information to:
       <br/><br/>- Communicate with you;
       <br/><br/>- Screen our orders for potential risk or fraud; and
       <br/><br/>- When in line with the preferences you have shared with us, provide you with information or advertising relating to our services.
       <br/><br/>We use the Device Information that we collect to help us screen for potential risk and fraud (in particular, your IP address), and more generally to improve and optimize our Site (for example, by generating analytics about how our customers browse and interact with the Site, and to assess the success of our marketing and advertising campaigns).
    </>,
    },
    {
      tilte:'How Do We Use Your Personal Information',
       content: <>We use the Order Information that we collect generally to fulfill any orders placed through the Site (including processing your payment information, arranging for shipping, and providing you with order confirmations). Additionally, we use this Order Information to:
       <br/><br/>- Communicate with you;
       <br/><br/>- Screen our orders for potential risk or fraud; and
       <br/><br/>- When in line with the preferences you have shared with us, provide you with information or advertising relating to our services.
       <br/><br/>We use the Device Information that we collect to help us screen for potential risk and fraud (in particular, your IP address), and more generally to improve and optimize our Site (for example, by generating analytics about how our customers browse and interact with the Site, and to assess the success of our marketing and advertising campaigns).
    </>,
    },
    {
      tilte:'Sharing Your Personal Information',
       content: <>We share your Personal Information with third parties to help us use your Personal Information, as described above. For example, we use Google Analytics to help us understand how our customers use the Site – you can read more about how Google uses your Personal Information. You can also opt-out of Google Analytics.
       <br/><br/>Finally, we may also share your Personal Information to comply with applicable laws and regulations, to respond to a subpoena, search warrant or other lawful request for information we receive, or to otherwise protect our rights.
    </>,
    },
    {
      tilte:'Behavioral Advertising',
       content: <>As described above, we use your Personal Information to provide you with targeted advertisements or marketing communications we believe may be of interest to you. For more information about how targeted advertising works, you can visit the Network Advertising Initiative’s educational page.
       <br/><br/>You can opt-out of targeted advertising at: Google's opt-out and Bing's opt-out. Additionally, you can opt-out of some of these services by visiting the Digital Advertising Alliance’s opt-out portal.
    </>,
    },
    {
      tilte:'Do Not Track',
       content: <>Please note that we do not alter our Site’s data collection and use practices when we see a Do Not Track signal from your browser.
    </>,
    },
    {
      tilte:'Your Rights',
       content: <>If you are a European resident, you have the right to access personal information we hold about you and to ask that your personal information be corrected, updated, or deleted. If you would like to exercise this right, please contact us through the contact information below.
       <br/><br/>Additionally, if you are a European resident we note that we are processing your information in order to fulfill contracts we might have with you (for example if you make an order through the Site), or otherwise to pursue our legitimate business interests listed above. Additionally, please note that your information will be transferred outside of Europe, including to Canada and the United States.
    </>,
    },
    {
      tilte:'Data Retention',
       content: <>When you place an order through the Site, we will maintain your Order Information for our records unless and until you ask us to delete this information.
    </>,
    },
    {
      tilte:'Changes',
       content: <>We may update this privacy policy from time to time in order to reflect, for example, changes to our practices or for other operational, legal or regulatory reasons.
    </>,
    },
    {
      tilte:'',
       content: <>For more information about our privacy practices, if you have questions, or if you would like to make a complaint, please contact us by email at <span className="hoveringTextLink" onClick={() => window.open('mailto:support@everbary.com', '_blank')}>support@everbary.com</span> or by mail using the details provided below: 
       <br/><br/>1209 Mountain Road Pl NE Ste N
       <br/>Albuquerque, NM 87110
    </>,
    },
  ]
  const { setColor, webP } = useContext(TransitionContext);

  useEffect(() => {
    setColor(false);
  }, [setColor]);

  const [isModalOpen, setIsModalOpen]=useState(false);
  const [isCreateAccountOpen, setIsCreateAccountOpen]=useState(false);


  const handleLoginOpen=(newState)=>{
    setIsModalOpen(newState);
  }

  const handleCreateAccountOpen=(newState)=>{
    setIsCreateAccountOpen(newState);
  }

  const { transitionTo } = useScreenTransition();
  

  return (
    <div className='bg-[#EFF3F5] w-full flex flex-col items-center cursor-default'>
    <SignInForm open={isModalOpen} isLoginFormOpen={handleLoginOpen} isCreateAccountOpen={handleCreateAccountOpen}/>
    <CreateAccount open={isCreateAccountOpen} isCreateAccountOpen={handleCreateAccountOpen} isLoginFormOpen={handleLoginOpen}/>


     {/* banner */}
     <div className='w-full md:p-4 p-2'>

      <div className='w-full bg-[#12ABBF] rounded-4xl max-md:rounded-xl max-md:pb-4'>
          {/* navbar */}
        <div className=' pt-[30px] pb-[27px] mx-4'>
            <Navbar windowSize={windowSize} isLoginFormOpen={handleLoginOpen}/>
        </div>
        <div className='bannerContainer px-2'>
            <h1 className='bannerText text-center'>Privacy Policy</h1>
        </div>
        <div className='flex flex-col gap-4 w-full items-center pb-[107px] max-md:pb-[30px] px-2'>
          <p className='text-[#fff] text-base text-center xl:w-[50%] md:w-1/2 w-full'>Learn how your personal information is collected, used, and shared when you visit or make a purchase from eVerbary.</p>
          <p className='text-[#fff] text-base text-center xl:w-[50%] md:w-1/2 w-full'>Last updated November 14, 2020</p>
        </div>
      </div>

     {privacyPolicy.map(policy => <div className="bg-white rounded-4xl overflow-hidden shadow-sm py-12 my-4 max-md:rounded-xl">
        <h2 className='font-secondary font-medium md:text-5xl text-4xl text-tertiary uppercase text-left mb-6 px-8'>{policy.tilte}</h2>
          <p className="px-8 w-full max-w-[1440px] justify-center mx-auto text-left text-xl">
           {policy.content}
           </p>
      </div>)}
    

      <SupportSection windowSize={windowSize} />

     </div>

    <div className=' w-full pb-10 bg-[#12ABBF]'>
          <Footer windowSize={windowSize} light={true}  />
      </div>  

  </div>
  
  );
}

export default Privacy;